/**
 * Card — Base card container with consistent styling.
 *
 * Props:
 *   children: ReactNode
 *   className: string — additional CSS classes
 *   padding: 'none' | 'sm' | 'md' | 'lg' — internal padding (default: 'md')
 *   hoverable: boolean — adds hover elevation effect
 *   onClick: () => void — makes the card clickable
 */

import React from 'react';
import styles from './Card.module.css';

function Card({ children, className, padding = 'md', hoverable = false, onClick, ...rest }) {
  const Component = onClick ? 'button' : 'div';

  const classNames = [
    styles.card,
    styles[`padding-${padding}`],
    hoverable && styles.hoverable,
    onClick && styles.clickable,
    className,
  ].filter(Boolean).join(' ');

  return (
    <Component
      className={classNames}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default Card;
